module.exports = __webpack_public_path__ + "static/img/7.1406477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjiancase/7.png
// module id = lwpT
// module chunks = 19